<div class="w-full flex flex-col gap-6">
    @if (deletedDoctorList.length > 0) {
        <cdk-accordion class="flex flex-col gap-6">
            <cdk-accordion-item #deletedDoctorAccordion="cdkAccordionItem" class="mt-8">
                <div
                    class="card bg-app-background-10 rounded-button shadow-sm border border-app-primary-10 overflow-hidden">
                    <button
                        class="flex justify-between items-center w-full p-6 text-app-primary-10 font-bold text-xl hover:bg-gray-50 transition-colors"
                        (click)="deletedDoctorAccordion.toggle()"
                        [attr.aria-expanded]="deletedDoctorAccordion.expanded">
                        <span>Ärztearchiv</span>
                        <i class="fa-solid self-center text-xl"
                           [ngClass]="deletedDoctorAccordion.expanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
                    </button>
                    @if (deletedDoctorAccordion.expanded) {
                        @for (doctor of deletedDoctorList; track doctor.id) {
                            <div class="p-6 border-b border-app-primary-10/5">
                                <div class="flex flex-col lg:flex-row justify-between w-full text-app-primary-20">
                                    <div class="flex flex-col">
                                        <div class="text-lg font-bold mb-4">
                                            {{ doctor.title ? doctor.title + ' ' : '' }} {{ doctor.firstName }} {{ doctor.lastName }}
                                        </div>
                                        <div class="grid grid-cols-2 gap-1">
                                            <div class="text-xs font-bold">
                                                E-Mail:
                                            </div>
                                            <div class="text-xs">
                                                {{ doctor.email }}
                                            </div>
                                            <div class="text-xs font-bold">
                                                Tel.:
                                            </div>
                                            <div class="text-xs">
                                                {{ doctor.phoneNumber }}
                                            </div>
                                            <div class="text-xs font-bold">
                                                Mobil.:
                                            </div>
                                            <div class="text-xs">
                                                {{ doctor.mobileNumber }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="justify-end flex flex-col mb-4">
                                        <button class="btn primary-button mt-4" (click)="triggerUndelete(doctor.id)">
                                            <span>Arzt wiederherstellen</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        }
                    }
                </div>
            </cdk-accordion-item>
        </cdk-accordion>
    }
</div>
